// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14Yfw","requiredAsterisk":"Info_requiredAsterisk__3iQ9A"};